import { css } from "@emotion/react"
import React from "react"
import { requestAnalyticsConsentReview } from "../../../analytics/runtime"

const actionStyles = css`
  min-height: 44px;
  margin-left: auto;
  padding: 0;
  color: inherit;
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  letter-spacing: inherit;
  text-decoration: underline;
  text-underline-offset: 0.2em;
  text-transform: inherit;

  &:hover {
    color: #fff;
  }

  &:focus-visible {
    color: #fff;
    outline: 2px solid var(--byfolio-focus);
    outline-offset: 2px;
  }
`

const FooterConsentAction = () => (
  <button
    css={actionStyles}
    data-test="privacy-settings"
    type="button"
    onClick={requestAnalyticsConsentReview}
  >
    Privacy settings
  </button>
)

export default FooterConsentAction
